const kuperShiftsItems = {
    colsOrder: ['time', 'count', 'amount', 'type', 'date', 'comment'],
    cols: {
        time: { content: 'Время', width: 10 },
        count: { content: 'Кол-во', width: 10 },
        amount: { content: 'Сумма', width: 10 },
        type: { content: 'Тип', width: 10 },
        date: { content: 'Дата', width: 10 },
        comment: { content: 'Комментарий', width: 30 },
    },
    deletesCols: [],
    url: 'kuperShiftItem',
    emptyInfo: {
        title: 'Смен пока нет',
    },
} as const;

export default kuperShiftsItems;
